import React, { useRef, useState } from "react";
import Layout from "../../layouts/Layout";
import BreadcrumbArea from "../../components/BreadcrumbArea/BreadcrumbArea";
import emailjs from "emailjs-com";
import { storage } from "../../appwrite/appwrite";
import { ID } from "appwrite";
import { useNavigate } from "react-router-dom";
import ReCAPTCHA from "react-google-recaptcha";
import { Bounce, toast } from "react-toastify";
import { Helmet } from "react-helmet";

function Appointment() {
  const recaptcha = useRef();
  const [isActive, setIsActive] = useState(false);
  const navigate = useNavigate();
  const [url, setUrl] = useState(null);
  const [url2, setUrl2] = useState(null);
  const form = useRef();
  const [loading, setLoading] = useState(false);
  const [loading2, setLoading2] = useState(false);
  const handleSubmit = (event) => {
    event.preventDefault();
    const formElements = form.current.elements;
    let isValid = true;
    // Loop through form elements to check for empty fields
    for (let i = 0; i < formElements.length; i++) {
      const element = formElements[i];
      if (element.hasAttribute("required") && !element.value) {
        isValid = false;
        element.focus(); // Focus on the first empty required field
        break; // Exit the loop after finding the first empty field
      }
    }
    if (isValid) {
      const captchaValue = recaptcha.current.getValue();
      const formData = new FormData(form.current);
      if (captchaValue) {
        emailjs
          .sendForm(
            "service_vg5tncb",
            "template_lcxwq0c",
            form.current,
            "hgObaD-j7KatO93BJ"
          )
          .then(
            (result) => {
              console.log("Email sent successfully:", result.text);
              toast('Your form has been submitted successfully.', {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: false,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
                transition: Bounce,
              });
              setTimeout(() => {
                navigate("/")
              }, 2000);
            },
            (error) => {
              console.log("Error sending email:", error.text);
              alert("Failed to send email. Please try again.");
            }
          );
      } else {
        alert("Please fill Captcha");
      }
    }
  };
  return (
    <>
      <Layout header={1} footer={1} className="" mainClassName="">
        <Helmet>
        <title>Appointment – Innovatix Hub Australia</title>
        <meta
          name="description"
          content="Innovatix Hub delivers innovative graphic design solutions that elevate your brand. Discover how our expert team can bring your vision to life. Contact us today!"
        />
        <meta name="robots" content="index,follow" />
        <meta name="author" content="Innovatix Hub" />
        <meta property="og:title" content="Pricing – Innovatix Hub Australia" />
        <meta
          property="og:description"
          content="Innovatix Hub delivers innovative graphic design solutions that elevate your brand. Discover how our expert team can bring your vision to life. Contact us today!"
        />
        <meta property="og:type" content="website" />
        <meta property="og:locale" content="en_AU" />
        <meta property="og:site_name" content="Innovatix Hub AU" />
        <meta property="og:url" content="https://innovatixhub.com.au/pricing" />
        <meta
          property="og:image"
          content="https://innovatixhub.com.au/img/logo1.webp"
        />
        <link rel="canonical" href="https://innovatixhub.com.au/pricing" />
      </Helmet>
        <BreadcrumbArea
          title={"Appointment"}
          subtitle={"Appointment"}
          className={"breadcrumb-area-two pt-175 pb-60"}
          showShape={false}
        />
        <div className="container consultation-form-wrap" style={{marginBottom: "3rem"}}>
          <form className="form-card" onSubmit={handleSubmit} ref={form}>
            <div className="row">
              <div className="form-group col-sm-6 form-grp">
                <label>First Name</label>
                <input
                  type="text"
                  name="first_name"
                  className="form-control"
                  placeholder="John"
                  required
                />
              </div>
              <div className="form-group col-sm-6 form-grp">
                <label>Last Name</label>
                <input
                  type="text"
                  name="last_name"
                  className="form-control"
                  placeholder="Doe"
                  required
                />
              </div>
              <div className="form-group col-sm-6 form-grp">
                <label>Email</label>
                <input
                  type="email"
                  name="email"
                  className="form-control"
                  placeholder="example@example.com"
                  required
                />
              </div>
              <div className="form-group col-sm-6 form-grp">
                <label>Phone</label>
                <input
                  type="text"
                  name="phone"
                  className="form-control"
                  placeholder="+61 0 000 000 0"
                  required
                />
              </div>
              <div className="form-group col-sm-6 form-grp">
                <label>Date</label>
                <input
                  type="date"
                  name="date"
                  className="form-control"
                  required
                />
              </div>
              <div className="form-group col-sm-6 form-grp">
                <label>Time</label>
                <input
                  type="time"
                  name="time"
                  className="form-control"
                  required
                />
              </div>
              <div className="form-group col-sm-12 form-grp">
                <label>Subject</label>
                <input
                  type="text"
                  name="subject"
                  className="form-control"
                  required
                />
              </div>
              <div className="form-group col-sm-12">
                <label>
                  message
                </label>
                <textarea
                  className="form-control form-grp-text-area"
                  placeholder=""
                  name="logo_desc"
                  rows="3"
                  required
                ></textarea>
              </div>
            </div>
          
            <div className="row justify-content-center my-4">
              <ReCAPTCHA
                sitekey={"6LfrdtUqAAAAAFb4hjwtai1FHpMgpU76t_oQNuuK"}
                ref={recaptcha}
              />
              <div className="col-sm-2">
                <button
                  type="submit"
                  className="btn"
                  disabled={loading || loading2 ? true : false}
                >
                  Submit
                </button>
              </div>
            </div>
          </form>
        </div>
      </Layout>
    </>
  );
}
export default Appointment;
